import { Component, OnInit } from '@angular/core';
import { Router, UrlSegment } from '@angular/router';
import { Location } from '@angular/common';
import { DecksService } from '../decks/decks.service';
import { UsersService } from '../users/users.service';

export interface PathPart {
    prettyName: string;
    linkValue: string;
}

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

    public pathParts: PathPart[];

    constructor(private readonly router: Router,
                private readonly location: Location,
                private readonly deckService: DecksService,
                private readonly userService: UsersService) { }

    public ngOnInit(): void {
        this.location.onUrlChange(this.handleUrlChange.bind(this));
    }

    private async handleUrlChange(url: string) {
        const urlTree = this.router.parseUrl(url);
        this.pathParts = [
            {
                prettyName: 'home',
                linkValue: 'home'
            }
        ];
        if (urlTree.root.children && urlTree.root.children.primary) {
            const pathParts = await this.processUrl(urlTree.root.children.primary.segments
                .filter((segment: UrlSegment) => !(segment.path === 'user-list' || segment.path === 'user-edit' || segment.path === 'home'))
                .map(segment => segment.path));
            this.pathParts = this.pathParts.concat(pathParts);
        }
    }

    private async processUrl(pathParts: string[]): Promise<PathPart[]> {
        // Run through the path parts and detect if we have a deck or a user; if so, we need to replace the ID with
        // a nicer name. We also want to display a pretty name, hence the PathParts intermediary object
        const detectedDeck = pathParts[0] === 'decks';
        const detectedUser = pathParts[0] === 'users';
        const newPathParts: PathPart[] = [];
        for (let i = 0; i < pathParts.length; i++) {
            const pathPart = pathParts[i];

            let prettyName = pathPart;

            if (i > 0 && detectedDeck && pathPart !== 'share' && pathPart !== 'public') {
                const deck = await this.deckService.get(pathPart).toPromise();
                prettyName = deck.name;
            } else if (i > 0 && detectedUser) {
                const user = await this.userService.getOne(parseInt(pathPart, 10)).toPromise();
                prettyName = user.alias;
            }

            newPathParts.push({
                prettyName,
                linkValue: pathPart
            });
        }

        return newPathParts;
    }

    public goTo(part: string) {
        if (part === 'home') {
            this.router.navigate(['/home']);
        } else {
            let path = '';
            for (const pathPart of this.pathParts.slice(1)) {
                path += `/${pathPart.linkValue}`;
                if (pathPart.linkValue === part) {
                    break;
                }
            }
            this.router.navigate([path]);
        }
    }
}
